export default __webpack_public_path__ + "static/media/customers-eating.760fc080.jpg";